import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function isNotBlank(_this__u8e3s4) {
  return !isBlank_0(_this__u8e3s4);
}
function isBlank_0(_this__u8e3s4) {
  return isBlank(_this__u8e3s4.r55_1) || isBlank(_this__u8e3s4.t55_1) || isBlank(_this__u8e3s4.v55_1);
}
//region block: exports
export {
  isNotBlank as isNotBlank2uco4vj45ytp1,
};
//endregion

//# sourceMappingURL=Address.ext.mjs.map
